import { Suspense } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { Layout } from './components/Layout'
import { HomePage } from './pages/HomePage'
import { lazyWithRetry } from './lib/lazyWithRetry'

// The home page ships in the main bundle; other pages load when visited.
const AdvertisePage = lazyWithRetry(() => import('./pages/AdvertisePage').then((m) => ({ default: m.AdvertisePage })))
const PrivacyPage = lazyWithRetry(() => import('./pages/PrivacyPage').then((m) => ({ default: m.PrivacyPage })))
const TermsPage = lazyWithRetry(() => import('./pages/TermsPage').then((m) => ({ default: m.TermsPage })))
const NotFoundPage = lazyWithRetry(() => import('./pages/NotFoundPage').then((m) => ({ default: m.NotFoundPage })))

function PageLoading() {
  return <div className="page-loading" role="status" aria-label="Loading"><span /></div>
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="advertise" element={<Suspense fallback={<PageLoading />}><AdvertisePage /></Suspense>} />
          <Route path="privacy" element={<Suspense fallback={<PageLoading />}><PrivacyPage /></Suspense>} />
          <Route path="terms" element={<Suspense fallback={<PageLoading />}><TermsPage /></Suspense>} />
          {/* Common wrong addresses go to the right page instead of a 404. */}
          <Route path="index.html" element={<Navigate to="/" replace />} />
          <Route path="home" element={<Navigate to="/" replace />} />
          <Route path="business" element={<Navigate to="/advertise" replace />} />
          <Route path="advertising" element={<Navigate to="/advertise" replace />} />
          <Route path="waitlist" element={<Navigate to="/#waitlist" replace />} />
          <Route path="privacy-policy" element={<Navigate to="/privacy" replace />} />
          <Route path="*" element={<Suspense fallback={<PageLoading />}><NotFoundPage /></Suspense>} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
